import { runInAction } from "mobx";
import { dashboardService } from "../services/dashboard.service";
import { dashboardEChartsStore } from "../stores/e-charts.store";
import { dashboardEmissionsBreakdownStore } from "../stores/emissions-breakdown.store";
import { dashboardFiltersStore } from "../stores/filters.store";
import { resolveReportingPeriodForYear } from "../utils/reporting-years";

export const loadEmissionsBreakdown = async () => {
  const store = dashboardEmissionsBreakdownStore;
  const seq = store.nextRequestSeq();
  const framework = dashboardFiltersStore.filters.frameworks?.[0] || null;
  const year = dashboardEChartsStore.selectedYear;
  const reportingPeriod = resolveReportingPeriodForYear(
    year,
    dashboardFiltersStore.available.reportingYears,
  );

  if (!Number.isFinite(year)) {
    runInAction(() => {
      store.setResult({
        scope: store.scope,
        year: null,
        unit: "tCO2e",
        rootOrganization: null,
        headline: null,
        rows: [],
        warnings: [{ code: "MISSING_YEAR" }],
      });
      store.setError("");
      store.setLoading(false);
    });
    return;
  }

  store.setLoading(true);
  store.setError("");

  try {
    const data = await dashboardService.getEmissionsBreakdown({
      scope: store.scope,
      year,
      framework,
      organizationIds: store.selectedOrgIds,
      ...(reportingPeriod || {}),
    });

    if (store.isStaleSeq(seq)) return;

    runInAction(() => {
      store.setResult(data);
    });
  } catch (error) {
    if (store.isStaleSeq(seq)) return;

    runInAction(() => {
      store.setError(
        error?.message || "Unable to load emissions breakdown right now.",
      );
      store.setResult({
        scope: store.scope,
        year,
        unit: "tCO2e",
        rootOrganization: null,
        headline: null,
        rows: [],
        warnings: [],
      });
    });
  } finally {
    if (!store.isStaleSeq(seq)) store.setLoading(false);
  }
};
